import { render, staticRenderFns } from "./koejakson-vaiheet-list.vue?vue&type=template&id=45d40e4b&scoped=true&"
import script from "./koejakson-vaiheet-list.vue?vue&type=script&lang=ts&"
export * from "./koejakson-vaiheet-list.vue?vue&type=script&lang=ts&"
import style0 from "./koejakson-vaiheet-list.vue?vue&type=style&index=0&id=45d40e4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d40e4b",
  null
  
)

export default component.exports